import {api} from '../_services'
const colors = ['unused', 'overused', 'poor', 'good', 'instagram', 'instagram-banned']

const state = {
    error: '',
    loading: false,
    hashtags: {}
}

const actions = {
    async get ({commit, state}, hashtagSelected = false) {
        console.log(state)
        commit('onRequest')
        try {
            const res = await api.hashtagStats(hashtagSelected)
            commit('onSuccess', {res})
        } catch (error) {
            commit('onError', error)
        }
    }
}

const getters = {
    getHashtag: state => {
        return state.hashtags
    }
}

const mutations = {
    onRequest (state) {
        state.loading = true
    },
    onSuccess (
        state,
        {
            res: {data}
        }
    ) {
        for(let hashtag of data.stats) {
            hashtag.class = colors[hashtag.color]
            state.hashtags[hashtag.hashtag] = hashtag
        }
        state.loading = false

    },
    onError (state, error) {
        state.loading = false
        state.error = error
    }
}

export const stats = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
